"use client"

import ErrorPage from "@/layout/ErrorPage"
import { useTranslations } from "next-intl"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Retrieve the translations for the error page
  const t = useTranslations("ErrorPage")

  // Prepare the data structure expected by the ErrorPage component
  const data = {
    subtitle: { value: t("subtitle") },
    text: { richText: `<p>${t("text")}</p>` },
    button: {
      links: [{ url: "/", name: t("button") }],
    },
    additionalButton: {
      links: [
        {
          url: "#",
          name: t("buttonPrevious"),
          onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
            e?.preventDefault()
            if (typeof window !== "undefined") {
              window.history.back()
            }
            reset()
          },
        },
      ],
    },
    image: {
      mediaItems: [{ url: "/personErrorPage.png" }],
    },
    changeSides: { value: false },
    noBackground: { value: false },
  }

  return <ErrorPage data={data} />
}
